// extracted by mini-css-extract-plugin
module.exports = {"level_0":"SuggestionDetails_level_0__1_tjK","level_1":"SuggestionDetails_level_1__2TFU0","level_2":"SuggestionDetails_level_2__2tYwS"};